import UaeMpciApiUrls from 'src/apiUrls/UaeMpciApiUrls'
import MpciApiClient from '../Common/services/MpciApiClient'

const DashboardService = {
  kpiUrl: UaeMpciApiUrls.DASHBOARD_KPI,
  statusCountsUrl: UaeMpciApiUrls.DASHBOARD_STATUS_COUNTS,
  announcementUrl: UaeMpciApiUrls.DASHBOARD_ANNOUNCEMENT,

    fetchKpi: (securedSendRequest, onSuccess, onError) => {
    securedSendRequest.execute(
      'GET',
      UaeMpciApiUrls.DASHBOARD_KPI,
      null,
      (response) => onSuccess && onSuccess(response.data),
      (error) => onError && onError(error),
      () => {},
      {},
      null
    )
  },

  fetchStatusCounts: (securedSendRequest, onSuccess, onError) => {
    securedSendRequest.execute(
      'GET',
      UaeMpciApiUrls.DASHBOARD_STATUS_COUNTS,
      null,
      (response) => onSuccess && onSuccess(response.data),
      (error) => onError && onError(error),
      () => {},
      {},
      null
    )
  },

  fetchAnnouncement: (onSuccess, onError) => {
    MpciApiClient.get(
      UaeMpciApiUrls.DASHBOARD_ANNOUNCEMENT,
      (data) => onSuccess && onSuccess(data),
      (error) => onError && onError(error)
    )
  }
}

export default DashboardService
